import CorporationsView from './views/CorporationViewMobile';

export default CorporationsView;